<iframe *ngIf="url" [src]="url" frameborder="0"></iframe>